/* eslint-disable react-hooks/exhaustive-deps */
import {
  PayPalButtons,
  PayPalScriptProvider,
  usePayPalScriptReducer,
} from "@paypal/react-paypal-js";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import AuthContext from "../utils/Auth";
import { useTranslation } from "react-i18next";
import { SaveSuscriptionPaypalInformation } from "../utils/Api/payPalServices";
import { PlanSelected } from "../types/videoTypes";

type Props = {
  selectedPlan: PlanSelected;
  tipoplan: string;
  idcliente: string;
};



export function PayPalPopUp(props: Props) {
  
  const { currentUser, GetUser } = useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const [keystate, setKeyState] = React.useState(Math.random());
  const [t] = useTranslation("global");
  const {selectedPlan,idcliente} = props;
const {idplan,subscriptionNumber} = selectedPlan;

  const SaveDataSuscription = async (data:ObjectConstructor, tiposub:string) => {
    const values = {
      paypalresponse:data,
      iduser:currentUser.id_player,
      fecha:new Date(),
      plan: tiposub,
      subscriptionNumber:subscriptionNumber,
    };
    SaveSuscriptionPaypalInformation(values).then((resp:any)=>{
      if(resp){
        console.log('Response callback =>  SaveSuscriptionPaypalInformation',resp);
        GetUser();
        Swal.fire(
          `${t("Suscriptions.ModalMessages.alreadyMember")}`,
          `${t("Suscriptions.ModalMessages.description")}`,
           "success"
         );
         window.location.reload();
      }
    }).catch((err:Error)=>{
      Swal.fire(
        `${t("Suscriptions.ModalMessages.errorMessage")}`,
        "Mensaje de error: " + err.toString(),
        "error"
      );
    });
  }
  const ButtonWrapper = ({ type }: any) => {
        const [{ options }, dispatch] = usePayPalScriptReducer();
    const [loadingInicial, setLoadinginicial] = useState(true);
    useEffect(() => {
      setTimeout(function () {
        dispatch({
          type: "resetOptions",
          value: {
            ...options,
            intent:type,
          },
        });

        setLoadinginicial(false);
      }, 100);
    }, [type]);

    return loadingInicial ? (
      <div className="cssload-loader">
        <div className="cssload-inner cssload-one"></div>
        <div className="cssload-inner cssload-two"></div>
        <div className="cssload-inner cssload-three"></div>
      </div>
    ) : (
      <PayPalButtons
        createSubscription={(data, actions) => {
          console.log('Cuales son las acciones a enviar',actions);
          console.log('Que datas se envian?',data);
          console.log('Que planID llega?',idplan);
          return actions.subscription
            .create({
              // plan_id: props.idplan,
              plan_id:idplan,
            })
            .then((orderId) => {
              return orderId;
            });
        }}
        onApprove={(data:any,actions:any) =>{
          SaveDataSuscription(data,props.tipoplan);
          console.log('Que devuelve actions?',actions);
          return actions.order;
  
        }}
        
        
        style={{
          label: "subscribe",
          layout:'vertical',
          shape:"pill",
          color:'blue',
        }}
      />
    );
  };

  useEffect(() => {
    setTimeout(function () {
      setKeyState(Math.random());
    }, 500);
  }, []);

  return (
    <>
      {loading ? (
        <div>
          <div className="cssload-loader">
            <div className="cssload-inner cssload-one"></div>
            <div className="cssload-inner cssload-two"></div>
            <div className="cssload-inner cssload-three"></div>
          </div>
          <p style={{ textAlign: "center" }}>{t("paypal.wait")}</p>
          <p style={{ textAlign: "center" }}>
            {t("paypal.ifScreen")}
          </p>
        </div>
      ) : (
        <div key={keystate}>
          <PayPalScriptProvider
            options={{
              // "client-id": "test",
              "client-id":idcliente,
              components: "buttons",
              intent: "subscription",
              currency:"USD",
              vault: true,
            }}
          >
            <ButtonWrapper type="subscription" />
          </PayPalScriptProvider>
          <br />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              className="btn btn-primary"
              onClick={() => {
                setKeyState(Math.random());
              }}
            >
             {t("paypal.recharge")}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
